import React, { useCallback, useEffect, useMemo } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useGetCmsHelpsQuery } from '../../apis/cmsApi/cms.hooks.api';
import Card from '../../components/Card/Card';
import { BaseLayout } from '../../components/Layout/Layout';
import { getFaqs } from '../../helpers/help';
import { useBack } from '../../hooks/useBack';
import { useLanguage } from '../../locale/useLanguage';
import { FaqFeature } from '../../models';
import { Routes } from '../../routes/types';

import './FeatureFaqView.css';

type FeatureFaqRouteParams = {
  feature?: FaqFeature;
};

type FeatureFaqViewProps = {};

export const FeatureFaqView: React.FC<FeatureFaqViewProps> = () => {
  const { feature } = useParams<FeatureFaqRouteParams>();
  const back = useBack();
  const history = useHistory();
  const languagesInfo = useLanguage();
  const t = languagesInfo[0];
  const locale = languagesInfo[2];

  const { data: helps } = useGetCmsHelpsQuery({ locale });

  useEffect(() => {
    if (!feature) {
      history.push(Routes.Home);
    }
  }, [feature, history]);

  const faqClick = useCallback(
    (id: number) => {
      return () => {
        history.push(
          Routes.FaqDetails.replace(':faqId', `${id}`).replace(
            ':feature',
            feature!
          )
        );
      };
    },
    [feature, history]
  );

  const correctFaqs = useMemo(() => {
    if (!feature || !helps) return undefined;
    return getFaqs(helps, feature);
  }, [feature, helps]);

  return (
    <BaseLayout title={t('pageTitles.faq')} hasBack isGreyBg onBackClick={back}>
      <div className="feature-faq--body">
        <div className="feature-faq--head">
          <h2 className="feature-faq--title">{t('faq.title')}</h2>
          <p className="paragraph">{t('faq.description')}</p>
        </div>
        {correctFaqs &&
          correctFaqs.map((h) => {
            return (
              <React.Fragment key={h.id}>
                <div className="feature-faq--card">
                  <a role="link" onClick={faqClick(h.id)} aria-label={h.title}>
                    <Card>
                      <h2 className="feature-faq--card-title">{h.title}</h2>
                      {h.description && (
                        <p className="feature-faq--card-description">
                          {h.description}
                        </p>
                      )}
                    </Card>
                  </a>
                </div>
              </React.Fragment>
            );
          })}
      </div>
    </BaseLayout>
  );
};
